import { Heading, Grid, Box, Icon, HeadingProps } from '@chakra-ui/react'
import ArrowIcon from '@/public/assets/icons/arrow-light.svg'

export const StageTitle = ({
  backCallback,
  title,
  textProps,
}: {
  title: string
  backCallback?: () => void
  textProps?: HeadingProps
}) => {
  if (!backCallback) {
    return (
      <Heading
        flexShrink={0}
        h={{ base: 7, md: 8 }}
        mb={{ base: 4, md: 6 }}
        textAlign={'center'}
        fontSize={{ base: '20px', md: '26px' }}
        {...textProps}
      >
        {title}
      </Heading>
    )
  }

  return (
    <Grid
      flexShrink={0}
      h={{ base: 7, md: 8 }}
      mb={{ base: 4, md: 6 }}
      alignItems={'center'}
      gridTemplateColumns={'28px auto 28px'}
    >
      <Box cursor={'pointer'} onClick={backCallback}>
        <Icon mt={1.5} transform={'rotate(180deg)'} h={{ base: 4, md: 4 }} w={5} as={ArrowIcon} />
      </Box>
      <Heading textAlign={'center'} fontSize={{ base: '20px', md: '26px' }} {...textProps}>
        {title}
      </Heading>
      <Box />
    </Grid>
  )
}
